import { useMemo } from 'react';

import { useBasicPropertiesFieldsSourceState } from '../BasicProperties/hooks';
import { useEnrollmentMatrixFieldsSourceState } from '../ComplexConfiguration/EnrollmentMatrix/hooks';
import { useCoverageLevelsFieldsSourceState } from '../CoverageLevels/hooks';

export default () => {
  const basicPropertiesState = useBasicPropertiesFieldsSourceState();
  const coverageLevelsFieldsSourceState = useCoverageLevelsFieldsSourceState();
  const enrollmentMatrixFieldsSourceState = useEnrollmentMatrixFieldsSourceState();
  const state = useMemo(() => ({
    ...basicPropertiesState,
    ...coverageLevelsFieldsSourceState,
    ...enrollmentMatrixFieldsSourceState,
  }), [basicPropertiesState, coverageLevelsFieldsSourceState, enrollmentMatrixFieldsSourceState]);
  return state;
};
